/* eslint-disable */
import userSlice from './user';
import persistedSlice from './persisted';
import candidateSlice from './candidate';
import threadSlice from './thread';
import campaignSlice from './campaign';
import { combineReducers } from '@reduxjs/toolkit';
import { userActions } from 'redux/actions';
import { clearDefaults } from 'util/Api/config';

const appReducers = combineReducers({
	user: userSlice.reducer,
	candidate: candidateSlice.reducer,
	thread: threadSlice.reducer,
	campaign: campaignSlice.reducer,
	persisted: persistedSlice.reducer
});

export default function rootReducer(state, action) {
	if (
		userActions.logout.fulfilled.match(action) ||
		userActions.sessionInfo.rejected.match(action) ||
		action.type === 'reset'
	) {
		// reducer will return the initial state when it received undefined,
		// thus resetting the entire global store
		clearDefaults();
		state = undefined;
	}
	return appReducers(state, action);
}
